import { List } from 'immutable';
import { lruMemoize } from 'reselect';

import {
    isResourceLoading,
    isResourceFailed,
    isResourceComplete,
    getResourceError,
    getResourceTotal,
    getResourcePage,
    getResourcePerPage,
} from './common';

const isCollateralRequestsLoading = lruMemoize(isResourceLoading);
const getCollateralRequestsTotal = getResourceTotal;
const getCollateralRequestsPage = getResourcePage;
const getCollateralRequestsPerPage = getResourcePerPage;
const getCollateralRequests = lruMemoize(
    (data) => data.get('collateral_requests', List()),
);

const isCollateralRequestLoading = lruMemoize(isResourceLoading);
const isCollateralRequestFailed = lruMemoize(isResourceFailed);
const isCollateralRequestComplete = lruMemoize(isResourceComplete);

const getCollateralRequestData = (state) => state.getIn(['app', 'collateralRequest']);

const getCollateralRequest = lruMemoize((data) => data.get('collateralRequest'));
const getCollateralRequestError = lruMemoize(getResourceError);

export {
    isCollateralRequestsLoading,
    getCollateralRequestsTotal,
    getCollateralRequestsPage,
    getCollateralRequestsPerPage,
    getCollateralRequests,
    isCollateralRequestLoading,
    getCollateralRequestError,
    isCollateralRequestFailed,
    isCollateralRequestComplete,
    getCollateralRequestData,
    getCollateralRequest,
};
